'use client';

import { useTracker } from '@lichtblick/tracker';
import { type FC, use, useEffect } from 'react';
import { useLoggedIn } from '@/tracking/use-logged-in';
import { Context } from '../components/tariffs-providers/electricity-tariffs-context';
import { createEcommerceItem } from '../tracking/create-ecommerce-item';

export const ECommerceTracking: FC<{ isComboCheckout: boolean }> = ({ isComboCheckout }) => {
  const tariffsContext = use(Context);
  const { isVirtPathTracked, trackEcommerceEvent } = useTracker();

  const loggedIn = useLoggedIn();

  useEffect(() => {
    if (!isVirtPathTracked) {
      return;
    }

    tariffsContext?.then(({ data }) => {
      if (!data) {
        return;
      }

      const tariffs = data.tariffs;

      if (tariffs?.length) {
        trackEcommerceEvent({
          event: 'Ecommerce - Item List Views',
          event_name: 'view_item_list',
          view_item_list: createEcommerceItem(tariffs, loggedIn, isComboCheckout),
        });
      }
    });
  }, [tariffsContext, trackEcommerceEvent, isComboCheckout, loggedIn, isVirtPathTracked]);

  return null;
};
